var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-2",attrs:{"color":"error","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("fas fa-trash-alt")]),(_vm.$vuetify.breakpoint.smAndUp)?_c('btn-title',[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }